import { __assign, __read, __spread, __values } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import isArray from 'lodash/isArray';
import { getMatchDetail, useResponsiveContext, } from '../../contexts/ResponsiveContext';
import { getMatchedSize, getSizeMap } from './utils';
/**
 * Make component can responsive size
 */
function withResponsive(Component, responsivePropKeys) {
    var responsiveKeys = __spread([
        'hiddenPatterns'
    ], responsivePropKeys);
    var ResponsiveComponent = forwardRef(function (props, ref) {
        var breakpoint = useResponsiveContext();
        var componentProps = responsiveKeys.reduce(function (props, key) {
            Reflect.deleteProperty(props, key);
            return props;
        }, __assign({}, props));
        var matchDetail = breakpoint === undefined ? null : getMatchDetail(breakpoint);
        var hidden = useMemo(function () {
            var e_1, _a;
            var _b;
            var hiddenPatterns = props.hiddenPatterns;
            if (hiddenPatterns === undefined)
                return false;
            // I think should hide component when context no pass breakpoint and hidden patterns is exist
            if (matchDetail === null)
                return true;
            if (!isArray(hiddenPatterns))
                return (_b = matchDetail.matchMap[hiddenPatterns]) !== null && _b !== void 0 ? _b : false;
            try {
                for (var hiddenPatterns_1 = __values(hiddenPatterns), hiddenPatterns_1_1 = hiddenPatterns_1.next(); !hiddenPatterns_1_1.done; hiddenPatterns_1_1 = hiddenPatterns_1.next()) {
                    var pattern = hiddenPatterns_1_1.value;
                    if (matchDetail.matchMap[pattern])
                        return true;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (hiddenPatterns_1_1 && !hiddenPatterns_1_1.done && (_a = hiddenPatterns_1.return)) _a.call(hiddenPatterns_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return false;
            // * compare hidden patterns directly
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, __spread([matchDetail], [props.hiddenPatterns].flat()));
        var patternCaches = useMemo(function () {
            var e_2, _a;
            var cache = {};
            try {
                for (var responsivePropKeys_1 = __values(responsivePropKeys), responsivePropKeys_1_1 = responsivePropKeys_1.next(); !responsivePropKeys_1_1.done; responsivePropKeys_1_1 = responsivePropKeys_1.next()) {
                    var responsivePropKey = responsivePropKeys_1_1.value;
                    var patternsOrSize = props[responsivePropKey];
                    // is pattern
                    if (isArray(patternsOrSize)) {
                        cache[responsivePropKey] = getSizeMap(patternsOrSize);
                    }
                    // is size, pass directly
                    else {
                        cache[responsivePropKey] = patternsOrSize;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (responsivePropKeys_1_1 && !responsivePropKeys_1_1.done && (_a = responsivePropKeys_1.return)) _a.call(responsivePropKeys_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return cache;
            // * compare all patterns directly
        }, 
        // eslint-disable-next-line react-hooks/exhaustive-deps
        responsivePropKeys.map(function (key) { return props[key]; }));
        var sizeProps = useMemo(function () {
            var e_3, _a;
            var result = {};
            if (matchDetail === null)
                return result;
            try {
                for (var responsivePropKeys_2 = __values(responsivePropKeys), responsivePropKeys_2_1 = responsivePropKeys_2.next(); !responsivePropKeys_2_1.done; responsivePropKeys_2_1 = responsivePropKeys_2.next()) {
                    var responsivePropKey = responsivePropKeys_2_1.value;
                    var sizeMapOrSize = patternCaches[responsivePropKey];
                    // is size, pass directly
                    if (typeof sizeMapOrSize !== 'object') {
                        result[responsivePropKey] = sizeMapOrSize;
                    }
                    // is size map
                    else {
                        var matchedSize = getMatchedSize(sizeMapOrSize, matchDetail);
                        if (matchedSize !== null) {
                            result[responsivePropKey] = matchedSize;
                        }
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (responsivePropKeys_2_1 && !responsivePropKeys_2_1.done && (_a = responsivePropKeys_2.return)) _a.call(responsivePropKeys_2);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return result;
        }, [matchDetail, patternCaches]);
        if (hidden) {
            // TODO: maybe we need addition props to control just set display: none, or visible: hidden
            return null;
        }
        return React.createElement(Component, __assign({}, componentProps, { ref: ref }, sizeProps));
    });
    ResponsiveComponent.displayName = "WithResponsive(" + Component.displayName + ")";
    return ResponsiveComponent;
}
export { withResponsive };
